import React, { useState } from "react";
import { FaUsers, FaBed, FaWifi, FaRulerCombined } from "react-icons/fa"; // Import React Icons
import { Swiper, SwiperSlide } from "swiper/react"; // Swiper library
import "swiper/css"; // Import Swiper styles
import { motion } from "framer-motion";
import { Pagination } from 'swiper/modules';
import 'swiper/css/pagination';

const FamilyRoom = ({
  roomName,
  description,
  images,
  price,
  capacity,
  bedType,
  area,
  wifi,
  roomIndex
}) => {


  const [currentSlide, setCurrentSlide] = useState(0);


   const pagination = {
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + '">' + (index + 1) + '</span>';
    },
  };
  
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="py-3 bg-light"
    >
      <div className="container">
        <div className="row align-items-center">
          <div
            className={`col-md-6 px-4 mb-3 ${roomIndex % 2 === 0 ? "order-md-1" : "order-md-2"}`}
          >
            <motion.h1
              initial={{ y: 20 }}
              animate={{ y: 0 }}
              className="display-4 mb-4"
            >
              {roomName}
            </motion.h1>
            <p className="text-muted mb-4">{description}</p>

            <div className="d-flex gap-4 mb-4">
              <div>
                <FaUsers className="me-2" />
                {capacity} Persons
              </div>
              <div>
                <FaBed className="me-2" />
                {bedType}
              </div>
            </div>

            <div className="d-flex gap-4 mb-4">
              <div>
                <FaRulerCombined className="me-2" />
                {area} sqft room
              </div>
              {wifi && (
                <div>
                  <FaWifi className="me-2" />
                  Free Wifi
                </div>
              )}
            </div>

            <div className="d-flex align-items-center gap-4">
              <h2 className="mb-0">${price}</h2>
              <p className="text-muted mb-0">/ night</p>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="btn btn-primary px-4 rounded-0"
              >
                Book now
              </motion.button>
            </div>
          </div>

          <div className={`col-md-6 mb-3 px-4 ${roomIndex % 2 === 0 ? "order-md-2" : "order-md-1"}`}>
            <div className="position-relative">
              <Swiper
                spaceBetween={10}
                slidesPerView={1}
                onSlideChange={(swiper) => setCurrentSlide(swiper.realIndex)}
                 pagination={pagination}
            modules={[Pagination]}
              >
                {images.map((slide, index) => (
                  <SwiperSlide key={index}>
                    <img
                      src={slide}
                      alt={roomName}
                      className="img-fluid"
                    />
                  </SwiperSlide>
                ))}
              </Swiper>

              {/* Custom Dots */}
              <div className="position-absolute bottom-0 start-50 translate-middle-x mb-3">
                <div className="d-flex gap-2">
                  {images.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentSlide(index)}
                      className={`btn btn-sm rounded-circle ${
                        currentSlide === index ? "btn-warning" : "btn-light"
                      }`}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default FamilyRoom;
